export const measuresPerCountryCode = {
  CN: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  },
  NL: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  },
  IN: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  },
  KR: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  },
  IT: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  },
  GB: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  },
  JP: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  },
  IS: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  },
  LV: {
    1: [['12-06-2000', '26-06-2000']],
    2: [['12-06-2000', '26-06-2000']],
    3: [['12-06-2000', '26-06-2000']],
    4: [['12-06-2000', '26-06-2000']]
  }
}